import BaseService from '../../base/base_service';
import IAbTestingService from './ab_testing_service_interface';
import {IAbTestingFeature, IAbTestingFeatureDataProviderService} from "../../../../app-react/services/ab-testing/ab-testing-feature-data-provider.service.interface";
import {NullableUndefinedString} from "../../../../common/types/nullable-types";


interface AbTestingServiceParams {
    abTestingFeatureDataProviderService: () => (IAbTestingFeatureDataProviderService | null);
}

export default class AbTestingService extends BaseService implements IAbTestingService {

    static CLASS = 'AbTestingService';

    private _params: AbTestingServiceParams;

    public init(params: AbTestingServiceParams): void {
        super.init(params);
		this._params = params;
    }

    getAnonymousPlayerId(): NullableUndefinedString {
        return this._params.abTestingFeatureDataProviderService()?.anonymousPlayerId;
    }


    getAbTestingDataForFeature(featureName: string): IAbTestingFeature | null {
        return this._params.abTestingFeatureDataProviderService()?.getFeature(featureName) ?? null;
    }
}
